'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';
import logHelper from 'com-gyf-webcore-loghelper/Content/App/Packages/LogHelper/LogHelper';

import {
    GET_DATOS_EDITAR_CONFIGURACION_PROCESO_DATA,
    GET_DATOS_EDITAR_CONFIGURACION_PROCESO_DATA_RESULT,
    SET_USER_FUNCTIONS,
    SELECT_RADIO_PROCESO,
    CHANGE_INPUT_PROCESO,
    SET_CHECK,
    SELECT_COMBO_PROCESO,
    ROUTE_TO_EDITAR_CONFIGURACION_PROCESO,
    VALIDATE_PROCESS,
    READY_REQUEST_PROCESS,
    INITIAL_STATE,
    GET_DATOS_CARTERAS,
    SHOW_SAVE_STATUS_PROCESO,
    CHECK_ARCHIVO_ASOCIADO,
    SET_LABEL_NOMBRE_ARCHIVO,
    SET_OPTION_NOMBRE_ARCHIVO,
    SET_RADIO_BUTTON_ARCHIVO,
    SET_NOMBRE_ARCHIVO,
    SET_NOMBRE_ARCHIVO_FINAL,
    SET_OPTION_FORMATO_FECHA_HORA,
    SET_DESCRIPCION_FORMATO_FECHA_HORA,
    SET_CAMPO_DESCRIPCION,
    SET_VARIABLES_NOMBRE_ARCHIVO_FINAL,
    VALIDAR_RDBUTTON,
    ERROR_NOMBRE_ARCHIVO,
    ERROR_FORMATO_FECHA_HORA,
    ERROR_FORMATO_NOMBRE_ARCHIVO
} from '../../Screens/EditarConfiguracionProceso/actions/Actions';

const initialState = {
    calendario: {
        DiaHabil: false,
        DiaMes: null,
        DiaDesdeCierre: null,
        DiaFin: null,
        DiaInicio: null,
        DiaSemanaLunes: false,
        DiaSemanaMartes: false,
        DiaSemanaMiercoles: false,
        DiaSemanaJueves: false,
        DiaSemanaViernes: false,
        DiaSemanaSabado: false,
        DiaSemanaDomingo: false,
        CarteraId: null,

    },
    listPeriodicidad: [
        { key: "Diario", value: "Diario" },
        { key: "Semanal", value: "Relativo a la semana" },
        { key: "Mensual", value: "Relativo al mes" },
        { key: "Cierre", value: "Relativo al cierre" },
        { key: "EntreDias", value: "Entre días" },
    ],
    proceso: {
        ProcesamientoParcial: false,
        PermiteVacio: false,
        LimiteRechazos: null,
        CantidadDiasHabilesReproceso: null,
        ArchivoAsociado: null,
        FormatoFechaArchivoId: null,
        FormatoHoraArchivoId: null,
        FormatoNombreArchivoId: null,
        TipoSeparacionArchivo: null
    },
    ERROR_PROCESS: {
        seleccionoPorcesamientoParcial: true,
        seleccionoPlazoMaximo: true,
        seleccionoDiaSemana: true,
        seleccionoDiaMensual: true,
        seleccionoCierre: true,
        seleccionoEntreDias: true
    },
    archivoAsociado: {
        //Valores con lo que se cargarán los combos de selección de formato
        optionNombreArchivo: undefined,
        optionFormatoFecha: undefined,
        optionFormatoHora: undefined,
        //Ids seleccionados en los combos de formato
        optionSeleccionadaFecha: "0",// opcion seleccionada por el usuario en el combo de formato de fecha
        optionSeleccionadaHora: "0",// opcion seleccionada por el usuario en el combo de formato de hora
        formatoOrdenArchivoCombo: "0",// opcion seleccionada por el usuario en el combo donde muestra los nombres de archivo
        //Radio Button de formato
        idRBFormato: null,
        //CheckBox de Formato Fecha y Hora
        checkFecha: false, // Si se encuentra checkeado -> optionSeleccionadaFecha tiene que ser != "0"
        checkHora: false, // Si se encuentra checkeado -> optionSeleccionadaHora tiene que ser != "0"
        //Datos con los que se escribirá el nombre final del archivo
        labelNombreArchivo: "", //lbl que se muestra sobre el combo de formatos, se irá modificando según lo seleccionado en el combo de fecha y hora
        nombreArchivoUsuario: "", //Se almacena el nombre del archivo seleccionado por el usuario
        descFormatoFechaUsuario: "",
        descFormatoHoraUsuario: "",
        descOrdenNombreArchivo: "", // Descripción seleccionada en el combo del orden para el formato del archivo
        nombreFinal: "", //es el nombre final que tendrá el archivo según las configuraciones realizadas por el usuario
        //Variables para validar errores
        errorNombreArchivo: false,
        errorComboFecha: false,
        errorComboHora: false,
        errorComboNombreArchivo: false,
        errorRadioButton: false,
    },
    formatoNombreArchivo: [],
    redirect: {
        shouldRedirect: false,
        to: null
    },
    inhabilitarModificarConfig: false,
    carteras: [],
    esDiaPositivo: false,
    DiasRespectoAlCierre: null,
    readyRequest: false,
    sagaId: null,
    calendarioId: null
}

function editarConfiguracionProceso(state = initialState, action) {
    LogHelper.In(editarConfiguracionProceso.name, state, action);
    let result;

    switch (action.type) {
        case INITIAL_STATE:
            state = initialState;


            result = {
                ...state
            }

            break;

        case GET_DATOS_EDITAR_CONFIGURACION_PROCESO_DATA: {
            LogHelper.In(editarConfiguracionProceso.name, state, action);

            const calendarioInicial = JSON.parse(JSON.stringify(state.calendario));

            result = {
                ...state,
                calendarioInicial
            };
        }
            break;
        case GET_DATOS_EDITAR_CONFIGURACION_PROCESO_DATA_RESULT: {
            LogHelper.In(editarConfiguracionProceso.name, state, action);
            const { proceso, calendario, carteras, formatoNombreArchivo } = action.result;


            let esDiaPositivo = calendario.DiaDesdeCierre > 0;
            let DiasRespectoAlCierre = esDiaPositivo ? (calendario.DiaDesdeCierre) : (calendario.DiaDesdeCierre * - 1)
            proceso.Periodicidad = getPeriodicidad(state, proceso.Periodicidad)

            const calendarioId = calendario.CalendarioId;
            const carteraId = calendario.CarteraId;


            result = {
                ...state,
                proceso,
                calendario,
                carteras,
                esDiaPositivo,
                DiasRespectoAlCierre,
                calendarioId,
                carteraId,
                formatoNombreArchivo,
                archivoAsociado: {
                    ...state.archivoAsociado,
                    optionFormatoFecha: action.result.optionFormatoFecha,
                    optionFormatoHora: action.result.optionFormatoHora
                }
            }


        }
            break;

        case GET_DATOS_CARTERAS: {
            LogHelper.In(editarConfiguracionProceso.name, state, action);
            const { carteras } = action.result;

            result = {
                ...state,
                carteras
            }

        }
            break;
        case SET_USER_FUNCTIONS: {
            LogHelper.In(editarConfiguracionProceso.name, state, action);
            result = {
                ...state,
                userFeatures: action._userFunctions,
                inhabilitarModificarConfig: action.inhabilitarModificarConfig
            };
        }
            break;
        case SELECT_RADIO_PROCESO: {
            LogHelper.In(editarConfiguracionProceso.name, state, action);

            const { list, item, params } = action;
            const newData = {};



            if (list == "ProcesamientoParcial") {
                result = {
                    ...state,
                    proceso: {
                        ...state.proceso,
                        [action.list]: item,
                        LimiteRechazos: null,
                        ...newData
                    }
                }
            } else if (list == "PermiteVacio") {
                result = {
                    ...state,
                    proceso: {
                        ...state.proceso,
                        [action.list]: item,
                        ...newData
                    }
                }
            } else {

                if (list == "esDiaPositivo") {
                    result = {
                        ...state,
                        [list]: item
                    }
                } else {

                    result = {
                        ...state,
                        proceso: {
                            ...state.proceso,
                            [action.list]: item,
                            ...newData
                        },
                        ["calendario"]: {
                            ...state.calendarioInicial
                        }
                    }
                }
            }

        }
            break;
        case CHANGE_INPUT_PROCESO: {
            LogHelper.In(editarConfiguracionProceso.name, state, action);
            // const { action, value } = action;
            const newData = {}

            result = {
                ...state,
                proceso: {
                    ...state.proceso,
                    [action.action]: action.value,
                    ...newData
                },
                calendario: {
                    ...state.calendario,
                    [action.action]: action.value,
                    ...newData
                },
                [action.action]: action.value,
                ...newData
            }
        }
            break;
        case SET_CHECK: {
            LogHelper.In(editarConfiguracionProceso.name, state, action);

            const newData = {}
            result = {
                ...state,
                proceso: {
                    ...state.proceso,
                    [action.name]: action.value,
                    ...newData
                },
                calendario: {
                    ...state.calendario,
                    [action.name]: action.value,
                    ...newData
                }
            };
        }
            break;


        case SET_DESCRIPCION_FORMATO_FECHA_HORA: {
            logHelper.In(editarConfiguracionProceso.name, state, action)

            result = {
                ...state,
                archivoAsociado: {
                    ...state.archivoAsociado,
                    [action.campo]: action.valor
                }
            };
        }
            break;

        case SET_CAMPO_DESCRIPCION: {
            logHelper.In(editarConfiguracionProceso.name, state, action)

            result = {
                ...state,
                archivoAsociado: {
                    ...state.archivoAsociado,
                    [action.campoDescripcion]: action.valor
                }
            };
        }
            break;

        case SET_LABEL_NOMBRE_ARCHIVO: {
            logHelper.In(editarConfiguracionProceso.name, state, action)

            result = {
                ...state,
                archivoAsociado: {
                    ...state.archivoAsociado,
                    labelNombreArchivo: action.labelNombreArchivo
                }
            };
        }
            break;

        case SET_OPTION_NOMBRE_ARCHIVO: {
            logHelper.In(editarConfiguracionProceso.name, state, action)

            result = {
                ...state,
                archivoAsociado: {
                    ...state.archivoAsociado,
                    optionNombreArchivo: action.optionNombreArchivo
                }
            };
        }
            break;

        case SET_RADIO_BUTTON_ARCHIVO: {
            logHelper.In(editarConfiguracionProceso.name, state, action)

            result = {
                ...state,
                archivoAsociado: {
                    ...state.archivoAsociado,
                    idRBFormato: action.valor
                }
            };
        }
            break;

        case SET_NOMBRE_ARCHIVO: {
            logHelper.In(editarConfiguracionProceso.name, state, action)

            result = {
                ...state,
                archivoAsociado: {
                    ...state.archivoAsociado,
                    nombreArchivoUsuario: action.valor
                }
            };
        }
            break;

        case SET_NOMBRE_ARCHIVO_FINAL: {
            logHelper.In(editarConfiguracionProceso.name, state, action)

            result = {
                ...state,
                archivoAsociado: {
                    ...state.archivoAsociado,
                    nombreFinal: action.valor
                }
            };
        }
            break;

        case SET_OPTION_FORMATO_FECHA_HORA: {
            logHelper.In(editarConfiguracionProceso.name, state, action)

            result = {
                ...state,
                archivoAsociado: {
                    ...state.archivoAsociado,
                    [action.campo]: action.valor
                }
            };
        }
            break;

        case CHECK_ARCHIVO_ASOCIADO: {
            LogHelper.In(editarConfiguracionProceso.name, state, action);

            let valorFecha = action.campo == 'checkFecha' && !action.valor ? null : state.archivoAsociado.optionSeleccionadaFecha;
            let valorHora = action.campo == 'checkHora' && !action.valor ? null : state.archivoAsociado.optionSeleccionadaHora;

            let descFecha = action.campo == 'checkFecha' && !action.valor ? '' : state.archivoAsociado.descFormatoFecha;
            let descHora = action.campo == 'checkHora' && !action.valor ? '' : state.archivoAsociado.descFormatoHora;

            result = {
                ...state,
                archivoAsociado: {
                    ...state.archivoAsociado,
                    [action.campo]: action.valor,
                    optionSeleccionadaFecha: valorFecha,
                    descFormatoFecha: descFecha,
                    optionSeleccionadaHora: valorHora,
                    descFormatoHora: descHora
                }
            };
        }
            break;
        
        case VALIDAR_RDBUTTON: {
            LogHelper.In(editarConfiguracionProceso.name, state, action);

            let rdbuttonValue = !action.checkFecha && !action.checkHora ? null : state.archivoAsociado.idRBFormato;

            //En el caso de que se destilde alguno de los checks de Fecha u Hora pero quede uno tildado, se restablece el valor por default del rdbutton == 1
            rdbuttonValue = (!action.checkFecha && action.checkHora) || (action.checkFecha && !action.checkHora) ? 1 : rdbuttonValue;

            result = {
                ...state,
                archivoAsociado: {
                    ...state.archivoAsociado,
                    idRBFormato: rdbuttonValue
                }
            };
        }
            break;

        case SELECT_COMBO_PROCESO: {

            const { valor, combo } = action;
            switch (combo) {
                /*REFERENCIA PRODUCTOS: buscar en actions metodo selectComboProducto*/
                case "CARTERAS": {

                    result = {
                        ...state,
                        calendario: {
                            ...state.calendario,
                            CarteraId: valor
                        }
                    }
                }
            }
        }
            break;
        case ROUTE_TO_EDITAR_CONFIGURACION_PROCESO: {
            result = {
                ...state,
                redirect: {
                    shouldRedirect: true,
                    to: action.data
                }
            }
        }
            break;

        case VALIDATE_PROCESS: {

            result = {
                ...state,
                ERROR_PROCESS: action.error
            }
        }
            break;

        case ERROR_NOMBRE_ARCHIVO: {

            result = {
                ...state,
                archivoAsociado: {
                    ...state.archivoAsociado,
                    errorNombreArchivo: action.valor
                }
            };
        }
            break;
            
        case ERROR_FORMATO_FECHA_HORA: {

            result = {
                ...state,
                archivoAsociado: {
                    ...state.archivoAsociado,
                    [action.campo]: action.valor
                }
            };
        }
            break;
        
        case ERROR_FORMATO_NOMBRE_ARCHIVO: {

            result = {
                ...state,
                archivoAsociado: {
                    ...state.archivoAsociado,
                    errorComboNombreArchivo: action.valor
                }
            };
        }
            break;

        case READY_REQUEST_PROCESS: {

            result = {
                ...state,
                readyRequest: true,
                errorSave: false

            };

        }
            break;
        //MUESTRA EL ID DE LA SAGA PARA EL RENDER DEL ESTADO.
        case SHOW_SAVE_STATUS_PROCESO: {

            result = {
                ...state,
                sagaId: action.sagaId,
                readyRequest: false
            };
        }
            break;

        case SET_VARIABLES_NOMBRE_ARCHIVO_FINAL: {
            logHelper.In(editarConfiguracionProceso.name, state, action)

            result = {
                ...state,
                proceso: {
                    ...state.proceso,
                    ArchivoAsociado: action.dataNombreArchivo.ArchivoAsociado,
                    FormatoFechaArchivoId: action.dataNombreArchivo.FormatoFechaArchivoId,
                    FormatoHoraArchivoId: action.dataNombreArchivo.FormatoHoraArchivoId,
                    FormatoNombreArchivoId: action.dataNombreArchivo.FormatoNombreArchivoId,
                    TipoSeparacionArchivo: action.dataNombreArchivo.TipoSeparacionArchivo
                }
            };
        }
            break;

        default:
            result = {
                ...state
            };
            break;

    }
    LogHelper.Out(editarConfiguracionProceso.name, result);
    return result;
}


export default editarConfiguracionProceso;


/*****************************************************************FUNCIONES AUXILIARES*****************************************************************
*********************************************************************************************************************************************************/

function getPeriodicidad(data, clave) {
    let periodicidad = "";
    data.listPeriodicidad.forEach((obj, value) => {
        if (obj.value == clave) {
            periodicidad = obj.key
        }
    });


    return periodicidad
}

